module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2d"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter02"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('h2', {
    staticClass: "h2b"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMINISM")]), _vm._v(", F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RONT AND")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTER")])]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor"
  }, [_c('em', [_vm._v("Linda Beail and Lilly J. Goren")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was an interesting experience to be working on this book during the 2008 primary season. Whatever one’s politics, the historic runs of Senator Hillary Rodham Clinton and Senator Barack Obama for the Democratic presidential nomination led to quite a few conversations about both race and gender in the United States, especially as culturally consumed through the media. This primary season prompted more public discussions about second- and third-wave feminism, postfeminism, the absence of feminism, misogyny, gender, racial and sexual discrimination, and so forth than have been heard in quite some time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As Senator Clinton concluded her campaign, an explicit discussion between second-wave feminists (Clinton supporters) and third-wave feminists (Obama supporters) blossomed, more thoughtfully and in more depth on the Internet than in most other media outlets, but this discussion was certainly not absent from television and radio news coverage, magazines, or newspapers. Prior to 2008, most of these conversations took place in the realm of academic conferences and books published by university presses—and there is certainly nothing wrong with these outlets. But the fact that these issues were suddenly front and center in analyzing the outcome of the presidential nomination process suggests how important they have become.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Just perusing the home pages of the major political Web sites, one finds countless analyses and counteranalyses of the role of women and feminism in the 2008 election season. It seems that feminism (in a variety of forms) has returned to our popular consciousness. Perhaps it never left, but it had been buried or shunted aside as something for only academics to study. Now we have just witnessed the highest-profile experience with feminism this "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("country has seen—Senator Clinton’s serious and significant campaign for the Democratic nomination. And although she did not achieve that end, the fact that her most reliable base of support was female (of a certain demographic composition: older, white, middle to lower income) brought forth much of this dialogue about feminism. The female vote in the United States has, for that past twenty-five to thirty years, been particularly important, especially in presidential elections."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en1fm2"
    }
  }, [_vm._v("1")])]), _vm._v(" And the fact that a woman has made a serious run for president gives us, as voters, an image we did not have before the 2008 election season. The particulars of this concept—the whole discussion of images of female presidents—are examined in greater depth in chapter 6, where Linda Horwitz and Holly Swyers explore why all the presidents are men and what this suggests about both the presidency and the patriarchy in the United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Of course, there is more to the discussion about feminism and popular culture than our understanding of who we “see” as presidential. All the chapters in this book examine the issues brought up by this election, the generational disagreements within feminism, the role of popular culture in our myriad understandings of feminism, and particularly the interactions between culture and feminism. This book examines quite a few areas where feminism and culture intersect, and the various analyses are framed by discussions of second- and third-wave feminism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The term "), _c('em', [_vm._v("third wave")]), _vm._v(" is often attributed to Rebecca Walker, who used it in a 1992 essay in "), _c('em', [_vm._v("Ms.")]), _vm._v(" magazine to refer to a generation of women who came of age enjoying the benefits of second-wave feminist activism from the 1960s and 1970s and whose politics are often more personal and contradictory than the “women’s liberation” social movement that preceded them."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en2fm2"
    }
  }, [_vm._v("2")])]), _vm._v(" The term was actually used earlier, in the late 1980s, by some feminists of color who proposed an anthology entitled "), _c('em', [_vm._v("The Third Wave: Feminist Perspectives on Racism,")]), _vm._v(" to be released by Kitchen Table: Women of Color Press. Although the anthology was never published, the challenge to white feminism by women of color is a key component of third-wave feminist thinking."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en3fm2"
    }
  }, [_vm._v("3")])]), _vm._v(" Other hallmarks typical of third-wave writing and thinking include conflict, ambiguity, and paradox; breaking down the essentialist construction of gender and insistence on women’s diversity; the notion that identity is multiple, intersecting, and shifting rather than conceptualized as a unified self; autobiography and personal experience as the foundation for feminist theorizing; engagement with popular culture; reclamation of some aspects of traditional femininity such as fashion, beauty culture, and domestic arts; celebration of women’s "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("sexual agency; coalition politics; and individual empowerment (more than social movement)."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en4fm2"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Television representations, music, and other “common texts” such as magazines, novels, and films are not incidental to understanding the third wave and its political potential. Popular culture is a crucial site for defining, shaping, and understanding this iteration of feminism. Influenced by critical theory and by generational immersion in mass-mediated culture, “third wave activists are well aware of the power of representations to promote or contest domination. Since we understand the ‘real’ as an effect of representation and understand that representational effects play out in material spaces and in material ways, we take critical engagement with popular culture as key to political struggle. Besides, we’re pop-culture babies; we want some pleasure with our critical analysis.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en5fm2"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Analyzing the ways that women’s lives are depicted on television, in film, through magazines, and in literature is legitimate political activism, because those representations are used by women (and men) to make meaning and create realities. “"), _c('em', [_vm._v("Representations")]), _vm._v(" of feminism” are also crucial because these representations cannot be dismissed as distortions or caricatures; they determine what feminism “really means” in the larger society, which is governed not by academic discourse but by “talk show audiences and "), _c('em', [_vm._v("Cosmo")]), _vm._v(" readers” who experience feminism, and femininity, through popular texts."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en6fm2"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The first two anthologies of third-wave feminist thinking, Rebecca Walker’s "), _c('em', [_vm._v("To Be Real")]), _vm._v(" and Barbara Findlen’s "), _c('em', [_vm._v("Listen Up,")]), _vm._v(" both of which appeared in 1995, did the same thing in essay form."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en7fm2"
    }
  }, [_vm._v("7")])]), _vm._v(" Both these collections consist of first-person essays by “young feminists” with diverse and sometimes unexpectedly contradictory identities. Walker’s includes a supermodel, a hip-hop fan, a lawyer disillusioned with success, a stripper, a Filipina, a black woman performance artist, a woman exploring bisexuality and transgenderism in cyberspace, an advocate of violence rather than pacifism, and a young woman whose deepest desire is to become a mother. Findlen’s anthology includes women who are married, bisexual, lesbian, androgynous, mothers, Christian, Jewish, African American, Asian, Indian, Bahamian, obese, HIV positive, formerly anorexic, and an aerobics instructor. If “testimony is where feminism starts,”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en8fm2"
    }
  }, [_vm._v("8")])]), _vm._v(" then these anthologies testify to a feminism that is diverse, paradoxical, and highly individual. Walker declares her motivation in her introduction:")]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("For many of us it seems that to be a feminist in the way that we have seen or understood feminism is to conform to an identity and way "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("of living that doesn’t allow for individuality, complexity, or less than perfect personal histories. We fear that identity will dictate and regulate our lives, instantaneously pitting us against someone, forcing us to choose inflexible and unchanging sides, female against male, black against white, oppressed against oppressor, good against bad. This way of ordering the world is especially difficult for a generation that has grown up transgender, bisexual, interracial . . . for us the lines between Us and Them are often blurred, and as a result we find ourselves seeking to create identities that accommodate ambiguity and our multiple positionalities: including more than excluding, exploring more than defining, searching more than arriving."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en9fm2"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although the characterization of second-wave feminism as “monolithic and cultish”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en10fm2"
    }
  }, [_vm._v("10")])]), _vm._v(" is criticized by some as an overstatement,"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en11fm2"
    }
  }, [_vm._v("11")])]), _vm._v(" the movement toward a more personally defined, ambiguous, and diverse feminism is unmistakable. And just as this text presents a variety of female viewpoints without “preferring” or affirming one of them as most correct, these anthologies present myriad young feminist voices without reconciling or judging them. There is no hierarchy of “most liberating” or “best” for women. Rather, these women define feminism through their own personal experiences and choices, especially if their own lives contradict or differ from the “conventional wisdom” of feminist politics; they affirm their own individual experience as broadening and more truly defining of feminism. In showcasing a variety of shifting, equally questioned and equally validated points of view rather than a defining narrative frame, the various topics in this text and the authors’ analyses serve much the same function.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, this volume is, like many other anthologies on feminism, especially third-wave feminism, fragmented and in many ways incomplete. Time and space limitations required that certain areas of popular culture be omitted. Alas, there are no chapters on comics or graphic novels or modern theater. Discussions of zines and blogs are embedded in a number of the chapters, but none is devoted specifically to these areas. There is no direct discussion of sports in this book (a topic that has filled volumes and will continue to do so). This book covers four broad areas, within which the various chapters tease out perspectives on a variety of the themes of popular culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Part I explores the idea of freedom and feminism. Within this context, the topic of much third-wave writing and theorizing is a “reputation for sexiness and frivolity.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en12fm2"
    }
  }, [_vm._v("12")])]), _vm._v(" Though acknowledging and incorporating the "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("second-wave critique of beauty culture and focus on sexual abuse, third-wave feminist thinking also “acknowledges and makes use of the pleasure, danger, and defining power of those structures [of beauty and sexuality].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en13fm2"
    }
  }, [_vm._v("13")])]), _vm._v(" Feminist theologian Emily Askew’s chapter 1 reflects on these two perspectives on beauty and sexuality, especially as they are omnipresent components of American culture. Askew concentrates on the cultural demand for beauty and the ease with which contestants on "), _c('em', [_vm._v("Extreme Makeover")]), _vm._v(" (and similar television shows) are willing to accept significant suffering and pain to become beautiful and desirable. This is not about sex so much as it is about the culturally entrenched longing to achieve a standardized beauty and the many ways in which our culture has legitimized this longing, regardless of what second-wave, third-wave, or postfeminism may suggest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Second-wave feminists such as Catherine MacKinnon problematized the notion of consent in heterosexual sex, noting the similarities in kind (if not degree) to rape, and they aggressively opposed pornography as harmful to women and a violation of their civil rights. Third-wave feminists are much more likely to take a “pro-sex” stand that opposes policing women’s desire and condones using female sexuality as a tool to gain power."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en14fm2"
    }
  }, [_vm._v("14")])]), _vm._v(" Advocating for women’s sexual freedom and agency may mean standing up for the rights of sex workers in pornography or prostitution or encouraging women to explore all kinds of sexual activity en route to finding what pleases them. The foundational third-wave anthologies demonstrate this in a variety of essays, including those by a feminist working as a stripper,"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en15fm2"
    }
  }, [_vm._v("15")])]), _vm._v(" women embracing lesbian desire,"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en16fm2"
    }
  }, [_vm._v("16")])]), _vm._v(" and very young women rejecting the label “promiscuous” and affirming their sexual pleasure and experimentation."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en17fm2"
    }
  }, [_vm._v("17")])]), _vm._v(" Political theorist Laurie Naranch integrates this dimension of sexual agency in her analysis of recent romantic comedies and the way some of these comedies circumvent the societal expectation of marriage. Naranch’s chapter 2 compares a variety of heterosexual romantic comedies, noting differences in presentations of femininity and feminism and some of the tensions that arise out of these perspectives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Rachel Henry Currans-Sheehan’s chapter 3 on pop music and feminism traces the evolution of women in the music business and the tensions among and between rockers, feminists, and feminist rockers. Currans-Sheehan exposes not only the difficulties women face in this highly marketed arena but also their successes and the particular paths they followed to achieve those successes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Parts II (“Housewives and Presidents”) and III (“The Mommy Brigade”) "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("have some crossover interests in their concentration on the way motherhood and femininity are constructed within popular culture conversations. Third-wave feminism has embraced “girly culture” and playfully reclaims elements of traditional femininity: knitting, domesticity, cooking, fashion, Barbie dolls, high heels, and makeup are interests and activities reinfused with possible feminist readings."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en18fm2"
    }
  }, [_vm._v("18")])]), _vm._v(" Theoretically, part of contemporary feminists’ aim is to reject the notion that women must meet masculine standards or norms to be seen as equal. “Difference” feminism and the rejection of female essentialism require room for diverse expressions of femininity and a revaluing of women’s traditional knowledge and experience, as well as an expansion of the realm of those experiences. On a practical level, this can be expressed by creating contradictory or unexpected identities (as feminist literary scholar Elaine Showalter did when she wrote an essay in "), _c('em', [_vm._v("Vogue")]), _vm._v(" discussing her love of shoes and fashion) or by reclaiming denigrated female activities as woman-centered spaces of fun and empowerment (the “Stitchn-Bitch” knitting class phenomenon). Joanne Hollows notes “an increasing fascination with the domestic as a forbidden pleasure” among contemporary feminists, who fantasize about baking, gardening, and rural escape from the pressures of modern life."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en19fm2"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Our two chapters, on the return of the evening soap opera (chapter 5 by Beail) and on the age of the pregnant assassin in film and television (chapter 8 by Goren), examine the manifestations of an evolving third-wave feminism as we look into the ironic, genre-bending, sexually assertive, and visually intriguing films and television shows that provide the substance of our analyses. The female characters at the heart of our analyses share many qualities of this contemporary feminist sensibility, reflecting and shaping women’s sense of their power, identity, and dilemmas in the new millennium. Peter Josephson and Rebecca Colton Josephson also explore third-wave televisual presentations through the lens of police procedurals, especially those that feature women at their center. Their chapter 4 connects the role of gender with the idea of reform and the need for an “outsider” to do this kind of work. The tension between femininity and agency is particularly relevant to the Josephsons’ discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Also included in Part III is Melissa Buis Michaux and Leslie Dunlap’s extensive and rigorously documented exploration of “mommy manuals.” In chapter 7 they examine the history and evolution of the most popular reference manuals for new parents (though, as they argue, these texts are marketed to and written for women). Their analysis delves into second- and "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("third-wave constructions of motherhood and the way these manuals have responded to those constructions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although the impulse to reject rigid and universal judgments of what is “good” or “bad” for women is reasonable, grounding contemporary feminism in individual taste and experience alone can lead to circular logic and the lack of any criteria to evaluate freedom, justice, and empowerment for women. The “seduction of the feminist free-for-all” can lead women to abandon politics in favor of “anything goes” feminism."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en20fm2"
    }
  }, [_vm._v("20")])]), _vm._v(" Television is particularly susceptible to reducing feminism to individual transformation and therapeutic rhetoric, as Naomi Rockler illustrates in her study of the sitcom "), _c('em', [_vm._v("Friends.")]), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en21fm2"
    }
  }, [_vm._v("21")])]), _vm._v(" Television dramas and sitcoms, films, and literature are similar in that they often present or resolve women characters’ dilemmas in personal and idiosyncratic ways. Those dilemmas are the problems of a postfeminist world in which women have achieved equality and overcome all the obstacles to opportunity; the challenges now become dealing with the pressure of so many options to choose from and heightened expectations for career, romance, and family."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en22fm2"
    }
  }, [_vm._v("22")])]), _vm._v(" But sociologist Julia Wilson notes in chapter 9 on the “mommy track” that we have not quite reached the postfeminist era, that this perfect equality does not exist in the United States (except on television or in film), even at the most rarefied levels, and certainly not at the lower economic levels. Wilson examines the rhetoric and the reality of the “mommy wars” and finds that equality is still absent, in many respects, from the American workplace. What is different, she notes, is that most women now "), _c('em', [_vm._v("have")]), _vm._v(" to work, so there are more women in the workforce and in the workplace. This contrasts with the advocacy of second-wave feminism, and the demands being made now, by many who fit into the third-wave generation, are different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Political scientist Mary McHugh also explores some of the differences in advocacy between second- and third-wave feminism in her chapter 12 on the rise of the female television anchor and women in the news business. McHugh’s research highlights some striking instances of discrimination in the TV news business, and she analyzes some of the limits of second-wave feminist advocacy in this particular profession, which is based as much on talent as on appeal. McHugh’s chapter is in Part IV, titled “What Do Women Want?” More specifically than some of the others, this part takes up the intersections of consumerism, popular culture outlets, and feminism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Third-wave feminism has pushed the limits of what it means to be a consumer in the United States, since our understanding of feminism comes "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("largely through the avenues by which we consume it—often the cultural avenues. Third-wave theory and method are characterized by individualism—hence the use of multiple first-person essays as a way to define it."), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en23fm2"
    }
  }, [_vm._v("23")])]), _vm._v(" But as Astrid Henry points out, this “ideology of individualism” can lead feminism to become watered down to one issue: personal “choice.” Floating free from a social movement and political implications, “feminism thus becomes an ideology of individual empowerment to make choices, no matter what those choices are.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "fm2en24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#en24fm2"
    }
  }, [_vm._v("24")])]), _vm._v(" And that choice can be about anything, from a pair of shoes at the local department store to a vote on election day to a new book at amazon.com. Part of Natalie Fuehrer Taylor’s argument in chapter 11 is that the so-called women’s magazines have been negotiating this tension between personal choice, as a reflection of feminism, and the place of politics in women’s magazines, which are supposed to appeal to the broadest market possible. Her analysis suggests that these magazines, often derided by feminists—but often read by feminists too—play an important connective role between individual empowerment and actual political participation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Cecilia Konchar Farr, a professor of American literature, explores the genre of “chick lit” in chapter 10. She makes an argument about the proper place for this “pink” genre, since it is not disassociated from the larger genre of the novel. She suggests that it has merely been “ghettoized,” perhaps in an effort to belittle both the texts and their readers. This contextualization brings together the multiple strands of the third-wave framework, the construction of feminism, the bifurcation of intellectual work by women from the “canon,” and the role of consumerism in our understanding of culture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All these chapters, in different voices and on different topics, come together to help us consider how we see feminism and gender in our society. The book is centered around popular culture in the United States (though some chapters do venture across oceans or borders) and how that culture, in its varied outlets, both influences our understanding of feminism and reflects back to us our thinking about feminism. One of the unexpected themes is the role of femininity in culture and society. All the chapters touch on this topic, some more than others, but the constant theme is that femininity is, itself, contested, constructed, and extremely political. One aspect of femininity, as opposed to feminism, is that it seems apolitical or unpolitical, somehow above the fray. Yet femininity is even more political because, unlike feminism, it makes no direct claim to the political. Thus, the construction of femininity—both how we see it and, more distinctly when exploring culture, how it is presented—is a thematic trope not only in "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("the analyses in this volume but also throughout our culture. Femininity, as defined by second-wave feminism, was the “domestic ideology” that framed life for many American women. This was what feminism initially reacted to and wanted to upend. But a significant tension remains with regard to how to “consume” femininity and what it might mean to do so. The authors in this volume explore this tension as it is refracted through their particular cultural subject matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Taken as a whole, this volume presents a broad examination of how women see themselves within American culture and how that culture sees women (and men). Has the demand and pursuit of gender equity opened up many doors while keeping other images (real or fictional) of women’s role in modern American society at odds with the daily experiences of most women? This book seeks to press the boundaries of what we think we know when we sit down to watch a television show or read a magazine. These experiences are meant to be entertaining, but they often convey reflected or even groundbreaking ideas to the viewer, the reader, or the consumer. How we react to and understand these ideas help form our basic notions of the role or place of both men and women in American society. This volume hopes to shed some light on those notions, perhaps even making us rethink our entertainment and consumer choices and our general acceptance of what is presented to us. This may make us more critical consumers, but it may also make us more aware of what feminism looks like today—whether it looks like one clearly defined entity or a variegated and still evolving concept. There may still be room for improvement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Within this volume there are also critiques of feminism, analyses of some of the limitations of both second- and third-wave feminism as movements and as theoretical frameworks. Some authors suggest that feminism may be in need of some gentle “corrections.” Others suggest that feminism has not gone nearly far enough. All these critiques are constructed through the lens of popular culture, the common language that Americans (and others) use to communicate and the way more complex issues are raised. In much the same way that feminism and racism were brought to the forefront by the 2008 primary campaign between a woman and an African American man, popular culture often provides the avenue for consideration of these topics. And as we think about all our choices, we might pause to consider what we are saying about ourselves through those choices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like so much in the evolution of feminism, this book stands on the shoulders of many that preceded it. And we owe a debt of gratitude to previous "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("authors, critics, thinkers, observers, and feminists for helping us see our way forward, for providing points of entry and intriguing ideas. We could not have built our analyses or arguments without those who came before us, and we acknowledge their insights and their arguments, even the ones we disagree with—"), _c('em', [_vm._v("particularly")]), _vm._v(" the ones we disagree with. It is our right, our freedom, and our reasoned opinion to both agree and disagree. We look forward to the next argument and the next dialogue.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en1fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en1"
    }
  }, [_vm._v("1")]), _vm._v(". Ever since 1980, more women than men have voted in presidential elections, and that number continues to increase. The other difference in this context is that women no longer vote for the same person their husbands vote for, which had once been the case.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en2fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en2"
    }
  }, [_vm._v("2")]), _vm._v(". Rebecca Walker is also currently involved in a very public dispute with her mother, novelist Alice Walker, and with the second-wave generation over the issues of motherhood and children. Walker’s criticism was published in the United Kingdom’s "), _c('em', [_vm._v("Daily Mail")]), _vm._v(" in May 2008; she wrote about some of the same themes in her memoir "), _c('em', [_vm._v("Baby Love")]), _vm._v(" (New York: Riverhead Hardcover, 2007). See also Rory Dicker and Alison Piepmeier, eds., "), _c('em', [_vm._v("Catching a Wave: Reclaiming Feminism for the 21st Century")]), _vm._v(" (Boston: Northeastern University Press, 2003), 10; Natalie Fixmer and Julia T. Wood, “The Personal Is Still Political: Embodied Politics in Third Wave Feminism,” "), _c('em', [_vm._v("Women’s Studies in Communication")]), _vm._v(" 28, no. 2 (2005): 235–57.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en3fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en3"
    }
  }, [_vm._v("3")]), _vm._v(". Astrid Henry, "), _c('em', [_vm._v("Not My Mother’s Sister: Generational Conflict and Third Wave Feminism")]), _vm._v(" (Bloomington: Indiana University Press, 2004); Daisy Hernandez and Bushra Rehman, eds., "), _c('em', [_vm._v("Colonize This! Young Women of Color on Today’s Feminism")]), _vm._v(" (Emeryville, CA: Seal Press, 2002).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en4fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en4"
    }
  }, [_vm._v("4")]), _vm._v(". Jennifer Gilley, “Writings of the Third Wave: Young Feminists in Conversation,” "), _c('em', [_vm._v("Reference and User Services Quarterly")]), _vm._v(" 44, no. 3 (spring 2005): 187–98; Barbara Arneil, "), _c('em', [_vm._v("Politics and Feminism")]), _vm._v(" (Oxford: Blackwell Publishers, 1999); Catherine M. Orr, “Charting the Currents of the Third Wave,” "), _c('em', [_vm._v("Hypatia")]), _vm._v(" 12, no. 3 (1997): 29–45; Dicker and Piepmeier, "), _c('em', [_vm._v("Catching a Wave.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en5fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en5"
    }
  }, [_vm._v("5")]), _vm._v(". Leslie Heywood and Jennifer Drake, eds., "), _c('em', [_vm._v("Third Wave Agenda: Being Feminist, Doing Feminism")]), _vm._v(" (Minneapolis: University of Minnesota Press, 1997), 51.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en6fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en6"
    }
  }, [_vm._v("6")]), _vm._v(". Orr, “Charting the Currents.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en7fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en7"
    }
  }, [_vm._v("7")]), _vm._v(". Rebecca Walker, ed., "), _c('em', [_vm._v("To Be Real: Telling the Truth and Changing the Face of Feminism")]), _vm._v(" (New York: Anchor Books, 1995); Barbara Findlen, ed., "), _c('em', [_vm._v("Listen Up: Voices from the Next Feminist Generation")]), _vm._v(" (Seattle: Seal Press, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en8fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en8"
    }
  }, [_vm._v("8")]), _vm._v(". Jennifer Baumgardner and Amy Richards, "), _c('em', [_vm._v("Manifesta: Young Women, Feminism, and the Future")]), _vm._v(" (New York: Farrar, Straus and Giroux, 2000).")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "en9fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en9"
    }
  }, [_vm._v("9")]), _vm._v(". Walker, "), _c('em', [_vm._v("To Be Real,")]), _vm._v(" xxxiii.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en10fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en10"
    }
  }, [_vm._v("10")]), _vm._v(". Orr, “Charting the Currents.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en11fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en11"
    }
  }, [_vm._v("11")]), _vm._v(". Fixmer and Wood, “The Personal Is Still Political”; Henry, "), _c('em', [_vm._v("Not My Mother’s Sister.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en12fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en12"
    }
  }, [_vm._v("12")]), _vm._v(". Dicker and Piepmeier, "), _c('em', [_vm._v("Catching a Wave,")]), _vm._v(" 10.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en13fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en13"
    }
  }, [_vm._v("13")]), _vm._v(". Heywood and Drake, "), _c('em', [_vm._v("Third Wave Agenda,")]), _vm._v(" 3.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en14fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en14"
    }
  }, [_vm._v("14")]), _vm._v(". Gilley, “Writings of the Third Wave.”")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en15fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en15"
    }
  }, [_vm._v("15")]), _vm._v(". Jocelyn Taylor, “Testimony of a Naked Woman,” in Walker, "), _c('em', [_vm._v("To Be Real.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en16fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en16"
    }
  }, [_vm._v("16")]), _vm._v(". Anastasia Higginbotham, “Chicks Goin’ at It,” in Findlen, "), _c('em', [_vm._v("Listen Up;")]), _vm._v(" Darice Jones, “Falling Off the Tightrope onto a Bed of Feathers,” in Hernandez and Rehman, "), _c('em', [_vm._v("Colonize This.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en17fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en17"
    }
  }, [_vm._v("17")]), _vm._v(". Rebecca Walker, “Lusting for Freedom,” in Findlen, "), _c('em', [_vm._v("Listen Up;")]), _vm._v(" Adriana Lopez, “In Praise of Difficult Chicas: Feminism and Femininity,” in Hernandez and Rehman, "), _c('em', [_vm._v("Colonize This;")]), _vm._v(" Soyon Im, “Love Clinic,” ibid.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en18fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en18"
    }
  }, [_vm._v("18")]), _vm._v(". Joanne Hollows and Rachel Moseley, eds., "), _c('em', [_vm._v("Feminism in Popular Culture")]), _vm._v(" (New York: Berg, 2006), 13; Gilley, “Writings of the Third Wave”; Baumgardner and Richards, "), _c('em', [_vm._v("Manifesta.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en19fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en19"
    }
  }, [_vm._v("19")]), _vm._v(". Hollows and Moseley, "), _c('em', [_vm._v("Feminism in Popular Culture,")]), _vm._v(" 98–108.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en20fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en20"
    }
  }, [_vm._v("20")]), _vm._v(". Dicker and Piepmeier, "), _c('em', [_vm._v("Catching a Wave,")]), _vm._v(" 17.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en21fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en21"
    }
  }, [_vm._v("21")]), _vm._v(". Naomi Rockler, “‘Be Your Own Windkeeper’: "), _c('em', [_vm._v("Friends,")]), _vm._v(" Feminism, and Rhetorical Strategies of Depoliticization,” "), _c('em', [_vm._v("Women’s Studies in Communication")]), _vm._v(" 29 (fall 2006): 244–65.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en22fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en22"
    }
  }, [_vm._v("22")]), _vm._v(". Amanda Lotz, "), _c('em', [_vm._v("Redesigning Women: Television after the Network Era")]), _vm._v(" (Urbana: University of Illinois Press, 2006), 108.")]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en23fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en23"
    }
  }, [_vm._v("23")]), _vm._v(". Findlen, "), _c('em', [_vm._v("Listen Up;")]), _vm._v(" Walker, "), _c('em', [_vm._v("To Be Real;")]), _vm._v(" Hernandez and Rehman, "), _c('em', [_vm._v("Colonize This.")])]), _vm._v(" "), _c('p', {
    staticClass: "notes"
  }, [_c('a', {
    attrs: {
      "id": "en24fm2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fm2en24"
    }
  }, [_vm._v("24")]), _vm._v(". Henry, "), _c('em', [_vm._v("Not My Mother’s Sister,")]), _vm._v(" 43–44.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336888be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 75
// module chunks = 0